import store from '@/store'

/**
 * Created by Fernando Torres on 22/03/2018.
 */

export default {
  onQuery (to, from, next) {
    store.dispatch('layouts/get', {id: to.params.id}).then(({data}) => {
      next()
    }).catch(error => {
      next(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/guards/designer.guards.js